/**
 * Datart
 *
 * Copyright 2021
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React, { memo } from 'react';
import MonacoEditor from 'react-monaco-editor';
import { useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { FONT_SIZE_BASE } from 'styles/StyleConstants';
import { selectThemeKey } from 'styles/theme/slice/selectors';

export interface TemplateEditorProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
}

export const TemplateEditor = memo(({ value, onChange }: TemplateEditorProps) => {
  const theme = useSelector(selectThemeKey);

  return (
    <EditorWrapper>
      <MonacoEditor
        value={value}
        language="javascript"
        theme={`vs-${theme}`}
        options={{
          fontSize: FONT_SIZE_BASE * 0.875,
          minimap: { enabled: false },
        }}
        onChange={onChange}
      />
    </EditorWrapper>
  );
});

const EditorWrapper = styled.div`
  position: relative;
  height: 300px;
`;
